import { render } from "./KpiReport.vue?vue&type=template&id=2ccdc7d8&scoped=true"
import script from "./KpiReport.vue?vue&type=script&lang=js"
export * from "./KpiReport.vue?vue&type=script&lang=js"

import "./KpiReport.vue?vue&type=style&index=0&id=2ccdc7d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ccdc7d8"],['__file',"src/views/h5/crm/kpi/KpiReport.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ccdc7d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ccdc7d8', __exports__)) {
    api.reload('2ccdc7d8', __exports__)
  }
  
  module.hot.accept("./KpiReport.vue?vue&type=template&id=2ccdc7d8&scoped=true", () => {
    api.rerender('2ccdc7d8', render)
  })

}


export default __exports__